/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/e.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns Euler’s number.
 *
 * @example
 * ROW E()
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'e',
  signatures: [
    {
      params: [],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
